<template>
  <div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell-group>
          <van-cell :title="item.type_name" :value="item.price" v-for="(item, index) in list" :key="index" :label="item.order_name" />
        </van-cell-group>
      </van-list>
    </van-pull-refresh>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Cell, CellGroup, List, PullRefresh } from 'vant'

  export default {
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
    },
    name: 'income',
    data () {
      return {
        page: 1,
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
      }
    },
    created () {
      //
    },
    methods: {
      onLoad () {
        this.$api.get('orders/income', {page: this.page, type: this.$route.query.type}, r => {
          let data = r.data.data
          this.list.push.apply(this.list, data)
          this.loading = false
          if (this.page >= r.data.last_page) {
            this.finished = true;
          }
          this.page = this.page + 1
        })
      },
      onRefresh () {
        this.page = this.page + 1
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/users/income.vue